<div
  id="orientation-warning-container"
  [style.display]="warningContainerDisplayProperty"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="120"
    viewBox="0 0 24 25"
    width="120"
  >
    <path
      d="M2.62571 17.1257C4.09444 20.3101 7.12038 22.5993 10.7218 22.9679L10.7142 24.4251C4.81353 23.8987 0.201516 18.8713 0.233581 12.7609L0.265695 12.1199L3.89747 15.8403L2.62571 17.1257ZM1.91966 11.0502C1.35726 10.4741 1.36211 9.55118 1.93047 8.99071L8.05781 2.84422C8.62622 2.27403 9.53663 2.2788 10.0894 2.85488L21.5472 14.5922C22.1096 15.1684 22.1047 16.0913 21.5364 16.6517L15.409 22.7982C14.8406 23.3684 13.9302 23.3636 13.3774 22.7876L1.91966 11.0502ZM20.526 15.6167L9.06822 3.87929L2.94089 10.0258L14.3986 21.7632L20.526 15.6167ZM20.8411 8.51676C19.382 5.33235 16.3465 3.04315 12.745 2.67452L12.7527 1.21733C18.6533 1.74375 23.2653 6.7711 23.2333 12.8816L23.2011 13.5226L19.5694 9.80217L20.8411 8.51676Z"
      fill="white"
    />
  </svg>

  <div id="warning-message">
    <h2>Please rotate your device to continue</h2>
    <p>This page cannot be viewed in the current orientation</p>
  </div>
</div>
